/**
 * The three ways a page can have nothing to show.
 *
 * Shared because the alternative is each route inventing its own wording, and
 * a user who hits two of them should not have to work out whether they mean
 * the same thing.
 */

import { Link } from 'react-router-dom';
import styles from './Page.module.css';

interface Props {
  title: string;
  children: React.ReactNode;
  /** Where to go instead. Omit when there is nowhere sensible. */
  action?: { to: string; label: string };
  /** `alert` interrupts a screen reader; `status` waits its turn. */
  tone?: 'status' | 'alert';
}

export function PageState({ title, children, action, tone = 'status' }: Props) {
  return (
    <div className={styles.state} role={tone}>
      <h2 className={styles.stateTitle}>{title}</h2>
      <p className={styles.stateBody}>{children}</p>
      {action && (
        <Link to={action.to} className={`${styles.btn} ${styles.btnPrimary}`}>
          {action.label}
        </Link>
      )}
    </div>
  );
}
